import type { Chart } from 'klinecharts';
import { useChartStore } from '@/store/chartStore';

type ChartWithIndicators = Chart & {
  createIndicator: (name: string, isStack: boolean, opts?: { id?: string }) => string;
  overrideIndicator: (o: { name: string; calcParams?: number[] }, paneId?: string) => void;
};

/**
 * Stacks RSI's overbought/oversold zones and divergence marks onto its pane.
 *
 * They are separate klinecharts indicators, not part of RSI itself, so they must
 * be created alongside it *every* time RSI is created — not only when the user
 * adds it from the toolbar. Whether each one actually draws is controlled by the
 * rsiZonesEnabled / rsiDivergenceEnabled settings.
 */
export function createRsiCompanions(chart: Chart, paneId: string): void {
  const c = chart as ChartWithIndicators;
  try { c.createIndicator('RSI_ZONES', true, { id: paneId }); } catch { /* ignore */ }
  try {
    c.createIndicator('RSI_DIVERGENCE', true, { id: paneId });
    const { rsiDivergencePeriod, rsiDivergencePivotLookback } = useChartStore.getState();
    c.overrideIndicator({ name: 'RSI_DIVERGENCE', calcParams: [rsiDivergencePeriod, rsiDivergencePivotLookback] }, paneId);
  } catch { /* ignore */ }
}
